import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { ReportListing } from '~/components/report/ReportListing';

export default function MyReportsRoute() {
  useBreadcrumb('routes/my-safari/reports', 'My Reports');

  return <ReportListing isCompany={false} />;
}
